<template>
  <div @click="handleClick">
    <slot :selectedPoints="localValue" />
    <van-popup
      v-model="visible"
      :round="true"
      position="bottom"
      :safe-area-inset-bottom="true"
      get-container="body"
      closeable
      @click.native.stop
    >
      <div :class="_.page">
        <div :class="_.hd">请选择消费金活动</div>
        <div :class="_.bd">
          <div :class="_.tips">当前商品共参与以下消费金活动</div>

          <div v-if="pointsData.length" :class="_.list">
            <div
              v-for="item in pointsData"
              :key="item.integralCouponId"
              :class="[
                _.item,
                !item.available && _.expired,
                localValue.integralCouponId &&
                  localValue.integralCouponId == item.integralCouponId &&
                  _.active,
              ]"
              @click.stop="handleCouponChange(item)"
            >
              <div :class="_.left">
                <div :class="_.desc">
                  <img src="./images/coupon.png" alt="" />
                  <div :class="_.text">
                    <div :class="_.name">{{ item.integralCouponName }}</div>
                    <div :class="_.time">
                      活动时间{{
                        item.startTime.replace(/-/g, '.') +
                        '-' +
                        item.endTime.replace(/-/g, '.')
                      }}
                    </div>
                  </div>
                </div>
                <div :class="_.balance">
                  余额￥<span>{{ item.integralBalance }}</span>
                </div>
              </div>

              <div :class="_.right">
                <img
                  :src="
                    localValue.integralCouponId &&
                    localValue.integralCouponId == item.integralCouponId
                      ? require('./images/checked.png')
                      : require('./images/nochecked.png')
                  "
                  alt=""
                />
              </div>
            </div>
          </div>

          <x-empty
            v-else
            v-bind="{
              message: '暂无消费金',
            }"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { apiActivityVirtualActivityFindUserIntegralCoupon } from '@/api'
  import { dcb } from '@dcb/jssdk'

  export default Vue.extend({
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
      value: {
        type: Object,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      visible: false,
      pointsData: [],
      loading: false,
    }),

    computed: {
      localValue: {
        get() {
          return this.value
        },
        set(v) {
          this.$emit('input', v)
        },
      },
    },

    watch: {
      visible: {
        immediate: true,
        handler() {
          if (this.visible) {
            this.prepareData()
          }
        },
      },
    },

    methods: {
      async prepareData() {
        const env = await dcb.getEnv()
        if (this.loading) {
          return
        }
        this.loading = true
        const data = await apiActivityVirtualActivityFindUserIntegralCoupon(
          { ...this.params, paymentMethod: env.wechat ? 2 : 1 },
          {
            noErrorToast: true,
          },
        ).catch(() => [])
        this.loading = false
        this.pointsData = data.userIntegralCouponList
      },

      handleClick() {
        this.visible = !this.visible
      },

      handleCouponChange(item) {
        this.visible = false
        this.$emit('input', item)
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    .hd {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      text-align: center;
      font-style: normal;
      padding-top: 13px;
    }

    .bd {
      margin-top: 20px;

      .tips {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        line-height: 17px;
        font-style: normal;
        padding-left: 12px;
      }

      .list {
        padding: 12px;
        height: 50vh;
        overflow: auto;

        .item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: url('./images/coupon_bg.png');
          background-size: 100% 100%;
          height: 117px;
          padding: 17px 12px;
          box-sizing: border-box;

          &:not(:first-child) {
            margin-top: 12px;
          }

          .left {
            .desc {
              display: flex;
              img {
                width: 34px;
                height: 34px;
                margin-right: 8px;
              }

              .text {
                .name {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 500;
                  font-size: 14px;
                  color: #333333;
                  line-height: 20px;
                  text-align: left;
                  font-style: normal;
                }
                .time {
                  margin-top: 2px;
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 12px;
                  color: #333333;
                  line-height: 17px;
                  text-align: left;
                  font-style: normal;
                }
              }
            }
            .balance {
              margin-top: 17px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 16px;
              color: #ff1c20;
              line-height: 22px;
              text-align: left;
              font-style: normal;
              span {
                font-family: Bebas-Regular;
                font-weight: 400;
                font-size: 30px;
              }
            }
          }

          .right {
            img {
              width: 20px;
              height: 21px;
            }
          }

          &.active {
            background: url('./images/coupon_bg_selected.png');
            background-size: 100% 100%;
            .left {
              .desc {
                .name {
                  color: #ffffff;
                }
                .time {
                  color: #ffffff;
                }
              }
            }
            .balance {
              color: #ffffff;
            }
          }

          &.expired {
            // pointer-events: none;
            // filter: grayscale(1) opacity(0.5);
          }
        }
      }
    }
  }
</style>
